const modulo_indexed_db = {
    strict: false,
    state: {
        count: 0,
        requests: [],
    },
    getters: {
        getPostCount: (state) => {
            return state.count;
        },
    },

    mutations: {
        setCount: (state, count) => {
            state.count = count;
        },
        setElements: (state, elements) => {
            state.requests = elements;
            if (!navigator.onLine) return;
            state.requests
                .forEach((element) => {
                    axios.post(element.url, JSON.parse(element.body));
                })
                .then((res) => {})
                .catch(function (error) {});
            const request = indexedDB.open("POSTRequestsDB");

            request.onerror = function (event) {
                console.error(
                    "Error opening IndexedDB database:",
                    event.target.error
                );
            };

            request.onsuccess = function (event) {
                const db = event.target.result;
                const transaction = db.transaction(
                    ["postRequests"],
                    "readwrite"
                );
                const objectStore = transaction.objectStore("postRequests");
                objectStore.clear();
                state.count = 0;
                state.requests = [];
            };
        },
    },

    actions: {
        getCountPost: (context, status) => {
            // Open a connection to the IndexedDB database
            const request = indexedDB.open("POSTRequestsDB");

            request.onerror = function (event) {
                console.error(
                    "Error opening IndexedDB database:",
                    event.target.error
                );
            };

            request.onsuccess = function (event) {
                const db = event.target.result;
                const transaction = db.transaction(
                    ["postRequests"],
                    "readonly"
                );
                const objectStore = transaction.objectStore("postRequests");
                // Use the count method to get the number of entries
                const countRequest = objectStore.count();
                countRequest.onsuccess = function (event) {
                    const count = event.target.result;
                    context.commit("setCount", count);

                    console.log("Number of entries in postRequest:", count);
                };
                countRequest.onerror = function (event) {
                    console.error(
                        "Error counting entries:",
                        event.target.error
                    );
                };
                const requests = objectStore.getAll();
                requests.onsuccess = function (event) {
                    context.commit("setElements", event.target.result);
                };
                requests.onerror = function (event) {
                    console.error(
                        "Error counting entries:",
                        event.target.error
                    );
                };
                // Close the transaction and the database connection
                transaction.oncomplete = function () {
                    db.close();
                };
            };

            request.onupgradeneeded = function (event) {
                // This event is only triggered if the database doesn't exist or needs upgrading
                const db = event.target.result;
                db.createObjectStore("postRequest");
            };
        },
    },
};

export default modulo_indexed_db;
